<script>
import mpx, { createApp } from '@mpxjs/core'
  import { utils } from '@didi/webx-js'
  mpx.mixin({
    methods: {
      toWebpByFin(image) {
        if (utils.webpUrl) {
          return utils.webpUrl(image)
        } else {
          console.warn('【fin】当前webx-js-sdk不支持utils.webpUrl，请升级')
          return image
        }
      }
    }
  }, ['page', 'component'])
  
import apiProxy from '@mpxjs/api-proxy'
import fetch from '@didi/mpx-fetch'
import { setLoginConfig, initSDK, canIUse } from '@didi/webx-js'

const loginConfig = {
  loginType: 'trinity',
  loginJsVersion: '2.0.8',
  productType: 'kf',
  useOauthCode: true,
}
initSDK({ branch: 'kfpassenger' })
canIUse('setLoginConfig') && setLoginConfig(loginConfig)
mpx.use(apiProxy, { usePromise: true }).use(fetch)
createApp({})
</script>

<style>

</style>

<script name="json">
module.exports = {
  pages: ['./index.mpx']
}
</script>
